import { CheckpointItem } from '@/apps/health_check/types/IHealthCheck';

export type SortDirection = 'asc' | 'desc';

export const getSortDirectionIcon = (direction: SortDirection): string =>
  direction === 'desc' ? '↓' : '↑';

export const getNestedProperty = (obj: any, path: string): any => {
  const keys = path.split('.');
  return keys.reduce(
    (o, key) => (o && o[key] !== undefined ? o[key] : null),
    obj
  );
};

export const stringComparator = (
  a: string | null | undefined,
  b: string | null | undefined
): number => {
  if (a === b) {
    return 0;
  }
  if (a === null || a === undefined) {
    return 1;
  }
  if (b === null || b === undefined) {
    return -1;
  }
  return a.localeCompare(b);
};

export const numberComparator = (
  a: number | null | undefined,
  b: number | null | undefined
): number => {
  if (a === b) {
    return 0;
  }
  if (a === null || a === undefined) {
    return 1;
  }
  if (b === null || b === undefined) {
    return -1;
  }
  return a - b;
};

export const dateComparator = (
  a: string | null | undefined,
  b: string | null | undefined
): number => {
  if (a === b) {
    return 0;
  }
  if (a === null || a === undefined) {
    return 1;
  }
  if (b === null || b === undefined) {
    return -1;
  }
  return new Date(a).getTime() - new Date(b).getTime();
};

export const getSortFieldLabel = <T extends string>(
  t: (key: string) => string,
  field: T,
  fieldMap: Record<T, (t: (key: string) => string) => string>
): string => (field in fieldMap ? fieldMap[field](t) : field);

/**
 * Generic over the checkpoint shape so read-only views can sort checkpoints
 * whose values may be absent, while callers passing CheckpointItem still get
 * CheckpointItem back.
 */
export const sortCheckpointsByTMinus = <
  T extends Pick<Partial<CheckpointItem>, 'startTimeThresholdMinutes'>,
>(
  checkpoints: T[] | undefined | null
): T[] => {
  if (!checkpoints) {
    return [];
  }
  return [...checkpoints].sort(
    (a, b) =>
      (Number(b.startTimeThresholdMinutes) || 0) -
      (Number(a.startTimeThresholdMinutes) || 0)
  );
};
